import { isSameDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

type WithDate<T> = T & {
    date: string; // ISO string
};

const createPastDateChecker = (timeZone: string) => {
    const now = new Date();
    const nowTZ = toZonedTime(now, timeZone);

    return (dateString: string) => {
        const date = new Date(dateString);
        const dateTZ = toZonedTime(date, timeZone);
        const isPastDate = dateTZ.valueOf() < nowTZ.valueOf();

        return isPastDate && !isSameDay(nowTZ, dateTZ);
    };
};

export function cutPastDates<T>(dates: WithDate<T>[], timeZone: string): WithDate<T>[] {
    if (!dates.length) {
        return [];
    }

    const isPastDate = createPastDateChecker(timeZone);

    return dates.filter((date) => !isPastDate(date.date));
}

export default cutPastDates;
